import { BASE_URL } from '../../App'
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Card } from 'antd';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LOGO from '../image/cri_logo.jpg';
import CustomTextField from "../Reusable/Numerictext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Collapse, FormGroup, Stack,Box, Backdrop, createTheme, ThemeProvider, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText, Checkbox, Grid, FormControlLabel } from '@mui/material';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { blue } from '@mui/material/colors';
import { saveAs } from 'file-saver';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import SearchIcon from '@mui/icons-material/Search';
import { Button as Btn, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
const styles = {
    tableContainer: {
        maxHeight: '400px',
        overflowY: 'auto',
    },
    headerCell: {
        fontWeight: 'bold',
        backgroundColor: blue[500], // Using MUI blue primary color
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '1rem',
    },
    bodyCell: {
        padding: '12px 16px',
        textAlign: 'center',
        fontSize: '0.875rem',
    },
    debitCreditCell: {
        padding: '12px 16px',
        textAlign: 'right',
        fontSize: '0.875rem',
    },
    tableRow: (index) => ({
        backgroundColor: index % 2 === 0 ? '#f1f1f1' : '#ffffff',
    }),
};

export default function PriceList() {


    const [subdealerlist, setsubdealerlist] = useState([]);
  
    const [showCard, setShowCard] = useState(false);
    const [open, setOpen] = React.useState(false);

  
    const [selectedDealer, setSelectedDealer] = useState(null);

  
    const login_id = localStorage.getItem("LOGIN_ID");
    const BRANCH_CODE = localStorage.getItem('BRANCH_CODE');
    const userGroupCode =localStorage.getItem('usertype');
    const token = localStorage.getItem('Token');
    const headers = { Authorization: `Bearer ${token}` };
    const [selectedValue, setSelectedValue] = useState({});

    const [selectedDate, setSelectedDate] = useState(dayjs());
    
    const [tableData, setTableData] = useState([]);
    const [period, setperiod] = useState(null);
    const [closing, setclosing] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedname, setSelectedname] = useState('');

    const [showTable, setShowTable] = useState(true);
    const [showfirstpage, setShowfirstpage] = useState(true);

    const [showactivity, setShowactivity] = useState(false);
    const [showcommon, setShowcommon] = useState(false);
    const [showexecutivedetails, setexecutivedetails] = useState(true);


    const [isActivityGroupFetched, setIsActivityGroupFetched] = useState(false);
    const[activitygrouplist ,setactivitygrouplist] =useState([]);
     const [selectedactivitygroup, setSelectedactivitygroup] = useState(null); 

     const[description,setdescription] = useState('');
     const[budget,setbudget] = useState('');
     const[Remark,setRemark] = useState('');
     const[dealerbudget,setdealerbudget] = useState('');
     const[dealerremark,setdealerremark] = useState('');
     const[expresult,setexpresult] = useState('');

     const billNoInputRef = useRef(null); 
     const fromdateInputRef = useRef(null); 
     const todateInputRef = useRef(null); 
     const activityobjectInputRef = useRef(null); 
     const budgetInputRef = useRef(null); 
     const dealerbudgetInputRef = useRef(null); 
     const dealerremarkInputRef = useRef(null); 
     const txtSPECIFIC_DETAILS2InputRef = useRef(null); 
     const [error, setError] = useState(null);
     const [errorfromdate, setErrorfromdate] = useState(null);
     const [errortodate, setErrortodate] = useState(null);
     const [erroractivityobject, setErroractivityobject] = useState(null);
     const [errorbudget, setErrorbudget] = useState(null);
     const [errordealerbudget, setErrordealerbudget] = useState(null);
     const [errordealerremark, setErrordealerremark] = useState(null);
     const [errortxtSPECIFIC_DETAILS2, setErrortxtSPECIFIC_DETAILS2] = useState(null);
     

     const [upload, setUpload] = useState([]);
    const [serialNoImage, setSerialNoImage] = useState([]);
     const handleuploadChange = (info) => {
       if (info.fileList) {
         setUpload(info.fileList); // Update the state with the file list
       }
     };
    

    // const login_id = "s4nQJJzkLN0X1YSjek9P86wH+83VnZxnTdzOohjEBN8psBDaMVVGjVVzZVYsz9UdoYDsvZtKrGFK85UoDHPv8A==";
    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
    };

    const handlGroupChange = (event, newValue) => {
        console.log('test', newValue)
        setSelectedDealer(newValue.Value);
    };

    useEffect(() => {
        // Sundealerlist();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL + '/mdpexecutiveid', { login_id: login_id,BranchCode:BRANCH_CODE,userGroupCode:userGroupCode });
                // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: '5103176' });
                if (response.status === 200) {
                    // setsubdealerlist(response.data.DEALER_CODE);
                    const dealerdata = response.data.executives;
                    const common = response.data.common_visible;

                    const Subdealer_List = dealerdata.map((type) => ({
                        value: type.LOGINID,
                        label: type.USER_NAME,
                      }));

     
                      if (common === true)
                      {
                        setShowcommon(true)
                      }

                    setsubdealerlist(Subdealer_List);
                    setSelectedGroup(Subdealer_List[0]);


                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }
        };
        fetchData();
    }, []);


    // get Activity Group
 
    



      const handleactivityGroupChange = (event, selectedOption) => {
        // This will be triggered when a branch is selected from the dropdown
        setSelectedactivitygroup(selectedOption);  // Update the selected branch
      };


    // end  get Activity Group

// end segmant load 
     const[activitydescriptionlist ,setactivitydescriptionlist] =useState([]);
     const [selecteddescriptiongroup, setSelecteddescriptiongroup] = useState(null); 
    

     const[segmentlist ,setsegmentlist] =useState([]);
     const [selectedsegment, setSelectedsegment] = useState(null); 
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL + '/fillmdpsegment');
                // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: '5103176' });
                if (response.status === 200) {
                    // setsubdealerlist(response.data.DEALER_CODE);
                    const segmentdata = response.data.data;
                    

                    const segment_List = segmentdata.map((type) => ({
                        value: type.SBU_Code,
                        label: type.SBU_Name,
                      }));

     
                    

                      setsegmentlist(segment_List);
                    setSelectedsegment(segment_List[0]);


                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }
        };
        fetchData();
    }, []);

    const handlesegmentChange = (event, selectedOption) => {
      // This will be triggered when a branch is selected from the dropdown
      setSelectedsegment(selectedOption);  // Update the selected branch
    };
    // end segmant load 

    useEffect(() => {
      const fetchData = async () => {
          try {
              const response = await axios.post(BASE_URL + '/fillmdpActivityGroup');
              if (response.status === 200) {
                  const activitydata = response.data.data;

                  const activitygroup_List = activitydata.map((type) => ({
                      value: type.PACTIVITYGROUP_CODE,
                      label: type.DESCRIPTION,
                  }));

                  setactivitygrouplist(activitygroup_List);
                  setSelectedactivitygroup(activitygroup_List[0]);

                  // After fetching, trigger the second API call
                  setIsActivityGroupFetched(true);
              } else {
                  Swal.fire({
                      icon: "warning",
                      text: 'Unexpected response status. Please try again.'
                  });
              }
          } catch (error) {
              if (error.response) {
                  Swal.fire({
                      icon: "warning",
                      text: `Error: ${error.response.data.message}`
                  });
              } else if (error.request) {
                  console.error('No response received');
              } else {
                  console.error('Error setting up the request:', error.message);
              }
          }
      };
      fetchData();
  }, []); // This runs once when the component mounts

  useEffect(() => {
      if (!isActivityGroupFetched) return;  // Prevent the second API call if first isn't fetched yet

      const fetchData = async () => {
          try {
              const response = await axios.post(BASE_URL + '/fillmdpCmdActivityType', { ActivityGroup: selectedactivitygroup.value });
              if (response.status === 200) {
                  const descriptiondata = response.data.data;

                  const description_List = descriptiondata.map((type) => ({
                      value: type.ACTIVITY_CODE,
                      label: type.DESCRIPTION,
                  }));

                  setactivitydescriptionlist(description_List);
                  setSelecteddescriptiongroup(description_List[0]);
              } else {
                  Swal.fire({
                      icon: "warning",
                      text: 'Unexpected response status. Please try again.'
                  });
              }
          } catch (error) {
              if (error.response) {
                  Swal.fire({
                      icon: "warning",
                      text: `Error: ${error.response.data.message}`
                  });
              } else if (error.request) {
                  console.error('No response received');
              } else {
                  console.error('Error setting up the request:', error.message);
              }
          }
      };
      fetchData();
  }, [isActivityGroupFetched, selectedactivitygroup]);


  const [labels, setLabels] = useState({
    Lblspec: 'Details (Size / Sq. Feet / No. of Participants)',
    Lblspec2: 'Details (Size / Sq. Feet / No. of Participants)'
});
const [visibility, setVisibility] = useState({
    Lblspec2: false,
    txtSPECIFIC_DETAILS2: false
});
const [txtSPECIFIC_DETAILS, setTxtSPECIFIC_DETAILS] = useState('');
const [txtSPECIFIC_DETAILS2, setTxtSPECIFIC_DETAILS2] = useState('');

  const [txtSPECIFIC_DETAILSmode, setTxtSPECIFIC_DETAILSmode] = useState(false);
const [txtSPECIFIC_DETAILS2mode, setTxtSPECIFIC_DETAILS2mode] = useState(false);
const [fileupload, setfileupload] = useState(false);

const [dropDownListVisible, setDropDownListVisible] = useState(false);
const [dropDownList, setDropDownList] = useState([]);
const [selectedDropDownList ,setselectedDropDownList]=useState([]);

useEffect(() => {
  // Ensure the first API call has completed successfully and description group is selected
  if (!selecteddescriptiongroup) return;

  const fetchData = async () => {
    try {
      const response = await axios.post(BASE_URL + '/mdploadTxt', { activity_code: selecteddescriptiongroup.value });
      if (response.status === 200) {
        // Extract data from the response
        const { data, labels, visibility, txtSPECIFIC_DETAILS, txtSPECIFIC_DETAILS2,txtSPECIFIC_DETAILSmode,txtSPECIFIC_DETAILS2mode, dropDownListVisible,fileuploadVisible, dropDownList } = response.data;

        // Set labels, visibility, and dropdown data
        setLabels(labels);
        setVisibility(visibility);
        setTxtSPECIFIC_DETAILS(txtSPECIFIC_DETAILS);
        setTxtSPECIFIC_DETAILS2(txtSPECIFIC_DETAILS2);

        setTxtSPECIFIC_DETAILSmode(txtSPECIFIC_DETAILSmode);
        setTxtSPECIFIC_DETAILS2mode(txtSPECIFIC_DETAILS2mode);

        setDropDownListVisible(dropDownListVisible);
        setDropDownList(dropDownList);

        if(fileuploadVisible ==='1')
        {
            setfileupload(true);
        }
        else
        {
          setfileupload(false);
        }
       

        const transformedDropDownList = dropDownList.map(item => ({
          value: item,    // The item itself can be the value
          label: item     // Display the same item as the label
        }));
        setDropDownList(transformedDropDownList);
     
        setselectedDropDownList (transformedDropDownList[0]);

      
      } else {
        Swal.fire({
          icon: "warning",
          text: 'Unexpected response status. Please try again.'
        });
      }
    } catch (error) {
      if (error.response) {
        Swal.fire({
          icon: "warning",
          text: `Error: ${error.response.data.message}`
        });
      } else if (error.request) {
        console.error('No response received');
      } else {
        console.error('Error setting up the request:', error.message);
      }
    }
  };

  fetchData();
}, [selecteddescriptiongroup]);


const handledeDropDownListChange = (event, selectedOption) => {
  // This will be triggered when a branch is selected from the dropdown
  setselectedDropDownList(selectedOption);  // Update the selected branch
};

const handleTextChange = (e) => {
  const value = e.target.value;

  // If in numeric-only mode
  if (txtSPECIFIC_DETAILSmode) {
    // Only allow numbers and empty string (for clearing input)
    if (/^\d*$/.test(value)) {
      setTxtSPECIFIC_DETAILS(value);
    }
  } else {
    // Allow any character (if mode is false)
    setTxtSPECIFIC_DETAILS(value);
  }
};

const handleTextChange2 = (e) => {
  const value = e.target.value;

  // If in numeric-only mode
  if (txtSPECIFIC_DETAILS2mode) {
    // Only allow numbers and empty string (for clearing input)
    if (/^\d*$/.test(value)) {
      setTxtSPECIFIC_DETAILS2(value);
    }
  } else {
    // Allow any character (if mode is false)
    setTxtSPECIFIC_DETAILS2(value);
  }
};

const handlesubmit = () => {

  

  

  if (!selectedfromDate) {
    setErrorfromdate('Please enter a From Date.'); // Set error message
    if (fromdateInputRef.current) {
      fromdateInputRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'center', // Center the input field in the viewport
        inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
      });
    }
    return; // Stop further processing (don't submit)
  } 
  
  if (!selectedtoDate) {
    setErrortodate('Please enter a To Date.'); // Set error message
    if (todateInputRef.current) {
      todateInputRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'center', // Center the input field in the viewport
        inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
      });
    }
    return; // Stop further processing (don't submit)
  } 
  if (!description) {
    setErroractivityobject('Please enter a Activity Objective.'); // Set error message
    if (activityobjectInputRef.current) {
      activityobjectInputRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'center', // Center the input field in the viewport
        inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
      });
    }
    return; // Stop further processing (don't submit)
  } 
 

  if (!txtSPECIFIC_DETAILS) {
    setError('Please enter a Specific details.'); // Set error message
    if (billNoInputRef.current) {
      billNoInputRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'center', // Center the input field in the viewport
        inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
      });
    }
    return; // Stop further processing (don't submit)
  } 

  if(txtSPECIFIC_DETAILS2mode===true)
    {
      if(dropDownListVisible===false)
        {
          if (!txtSPECIFIC_DETAILS2) {
            setErrortxtSPECIFIC_DETAILS2('Please enter a Specific Detials 2.'); // Set error message
            if (fromdateInputRef.current) {
              fromdateInputRef.current.scrollIntoView({
                behavior: 'smooth', // Smooth scroll effect
                block: 'center', // Center the input field in the viewport
                inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
              });
            }
            return; // Stop further processing (don't submit)
          } 
        }
    }

  if (!budget) {
    setErrorbudget('Please enter a Budget.'); // Set error message
    if (budgetInputRef.current) {
      budgetInputRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'center', // Center the input field in the viewport
        inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
      });
    }
    return; // Stop further processing (don't submit)
  } 
  if (!dealerbudget) {
    setErrordealerbudget('Please enter a  Dealer Budget.'); // Set error message
    if (dealerbudgetInputRef.current) {
      dealerbudgetInputRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'center', // Center the input field in the viewport
        inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
      });
    }
    return; // Stop further processing (don't submit)
  } 

  if (!dealerremark) {
    setErrordealerremark('Please enter a  Remarks.'); // Set error message
    if (dealerremarkInputRef.current) {
      dealerremarkInputRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'center', // Center the input field in the viewport
        inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
      });
    }
    return; // Stop further processing (don't submit)
  } 

  setOpen(true);
  const formData = new FormData();
//alert(isCheckedassign);
console.log('description',selecteddescriptiongroup);
console.log('fyear',selectedItem);
  // upload.forEach(file => {
  //   formData.append('file', file.originFileObj); // `originFileObj` gives the raw file object
  // });

  //  upload.forEach(file => {
  //     formData.append('file', file.originFileObj); // Append the actual file object
  //     formData.append('fileName', file.name); // Append the file name (e.g., RHData.csv)
  //   });
  // Add form fields to FormData object
   formData.append('file', serialNoImage[0]);
  formData.append('login_id', login_id);
  if(isCheckedassign===true)
  {
    formData.append('dealer_code', selectedBranch.value);
  }else
  {
    formData.append('dealer_code', dealercode);
  }
  //formData.append('activity_code', selectedRowData.ACTIVITY_CODE);
  
  formData.append('commonactivity', isCheckedassign);
  formData.append('branchcode', selectedBranch.value);
  formData.append('activityType', selecteddescriptiongroup.value);
  const formattedDate = new Date(selectedfromDate).toLocaleDateString('en-CA'); // 'en-CA' returns YYYY-MM-dd format
  const formattedtoDate = new Date(selectedtoDate).toLocaleDateString('en-CA'); // 'en-CA' returns YYYY-MM-dd format

  formData.append('fromdate', formattedDate);  
  //formData.append('fromdate', selectedfromDate);
   formData.append('toDate', formattedtoDate);
  formData.append('description', description);
  formData.append('budget', budget);
  formData.append('budgetRemarks', Remark);
  formData.append('activityGroupCode', selectedactivitygroup.value);
  formData.append('dealerContribution', dealerbudget);
  formData.append('dealerContributionRemark', dealerremark);
  formData.append('expectedResult', expresult);
  const fYear = selectedItem.Value.split('-')[0]; // Split by "-" and take the first part

  formData.append('fYear', fYear);
  if(dropDownListVisible===true){


    formData.append('specificDetails2', selectedDropDownList.value || "");
 
  }
  else
  {
    
    formData.append('specificDetails2', txtSPECIFIC_DETAILS2 || "");
 
  }
  formData.append('specificDetails', txtSPECIFIC_DETAILS || "");
  formData.append('segmentCode', selectedsegment.value);
  formData.append('segmentName', selectedsegment.label);
  
  axios.post(BASE_URL + '/mdpdocumentcreate', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',  // Important to set this header for file uploads
    }
  })
    .then(response => {
      if (response.status === 200) {
        setOpen(false);
                      Swal.fire({
                          icon: "success",
                          text: response.data.text || 'Data saved successfully!',
                      }).then((result) => {
                        setOpen(false);
                          if (result.isConfirmed) {
                              window.location.reload();
                          }
                      });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "warning",
          text: 'Unexpected response status. Please try again.'
        });
      }
    })
    .catch(error => {
      setOpen(false);
      if (error.response) {
        Swal.fire({
          icon: "warning",
          text: `Error: ${error.response.data.text}`
        });
      } else if (error.request) {
        console.error('No response received');
      } else {
        console.error('Error setting up the request:', error.message);
      }
    });
};



      const handledescriptionGroupChange = (event, selectedOption) => {
        // This will be triggered when a branch is selected from the dropdown
        setSelecteddescriptiongroup(selectedOption);  // Update the selected branch
      };


    //end get activity description

    const [financialYearCount, setFinancialYearCount] = useState(0);
    const [financialYearOptions, setFinancialYearOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null); // Initialize the selected item
  
    // Fetch financial year count from the server
    useEffect(() => {
      const fetchFinancialYearCount = async () => {
        try {
          const response = await axios.post(BASE_URL + '/mdpyearcount', { login_id: login_id });
          if (response.status === 200) {
            setFinancialYearCount(response.data.mdpyearcount);
          } else {
            Swal.fire({
              icon: "warning",
              text: 'Unexpected response status. Please try again.'
            });
          }
        } catch (error) {
          console.error('Error fetching financial year count:', error);
        }
      };
      fetchFinancialYearCount();
    }, [login_id]);
  
    // Generate options once financialyearcount is available
    useEffect(() => {
      if (financialYearCount > 0) {
        const options = generateFinancialYearOptions();
        setFinancialYearOptions(options);
  
        // Set the default selected item to the first option
        if (!selectedItem && options.length > 0) {
          setSelectedItem(options[0]);
        }
      }
    }, [financialYearCount, selectedItem]);
  
    // Function to generate financial year options
    // const generateFinancialYearOptions = () => {
    //   const options = [];
    //   const currentYear = new Date().getFullYear();
  
    //   for (let i = 1; i < financialYearCount+1; i++) {
    //     const startYear = currentYear - i;
    //     const endYear = startYear + 1;
    //     const financialYearName = `${startYear}-${endYear}`;
    //     options.push({ Value: financialYearName, Label: financialYearName });
    //   }
  
    //   return options;
    // };
   const generateFinancialYearOptions = () => {
  const options = [];
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // Jan = 1

  // Determine financial year start
  let startYear = currentMonth <= 3 
    ? currentYear - 1   // Jan–Mar → previous FY
    : currentYear;      // Apr–Dec → current FY

  while (startYear >= 2013) {
    const endYear = startYear + 1;
    const financialYearName = `${startYear}-${endYear}`;
    options.push({
      Value: financialYearName,
      Label: financialYearName
    });
    startYear--;
  }

  return options;
};

    
    
  
    // Handle the change event for selecting a new item
    const handleItemChange = (event, newValue) => {
      setSelectedItem(newValue);
    };
    const acceptedFileTypes = [
      'image/jpeg',    // .jpg, .jpeg
      'image/png',     // .png
      'application/pdf',   // .pdf
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-powerpoint',  // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/zip', // .zip
      'text/plain',  // .txt
      'text/csv'     // .csv
    ];
    const createInvoiceImageProps = (image, setImage) => ({
     // accept: '.pdf',
      onRemove: (file) => {
        const newFileList = image.filter(item => item.uid !== file.uid);
        setImage(newFileList);
      },
      beforeUpload: (file) => {
        const isAcceptedFileType = acceptedFileTypes.includes(file.type);
        if (!isAcceptedFileType) {
          message.error('You can only upload PDF files!');
          return false;
        }
        setImage([file]);
        return false; 
      },
      fileList: image,
    });



    const [pendingStatusCount, setPendingStatusCount] = useState([]);
    const [pendingStatus, setPendingStatus] = useState([]);
  const [loading, setLoading] = useState(true);
 

  useEffect(() => {
    const fetchPendingStatus = async () => {
      try {
        setOpen(true);
        const response = await axios.post(BASE_URL + '/loadmdppendingstatus', { login_id: login_id,userGroupCode:userGroupCode });
        
        if (response.status === 200) {
          // Check if the API response contains data
          if (response.data.pendingStatusCount) {
            setPendingStatusCount(response.data.pendingStatusCount);
          }
          if (response.data.pendingStatus) {
            setPendingStatus(response.data.pendingStatus);
          }
        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
      
      } finally {
        setOpen(false);
      }
    };

    fetchPendingStatus();
  }, [login_id]);

  const maxRows = 6;
  const rowCount = pendingStatus.length;


    const [subgrouppcode, setsubgrouppcode] = useState([]);

    const handleGroupChange = (event, selectedOption) => {
        // This will be triggered when a branch is selected from the dropdown
        setSelectedGroup(selectedOption);  // Update the selected branch
      };

    

      

    
    const [rptcode, setrptcode] = useState([]);



    const [selectedDealername, setSelectedDealername] = useState('');



    //handlitemChange

    const [selecteditemdesc, setselecteditemdesc] = useState('');
    const [mdpgrid, setmdpgrid] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
          setOpen(true);
            try {
                const response = await axios.post(BASE_URL + '/mdploadgrid', { login_id: login_id,BranchCode:BRANCH_CODE,userGroupCode:userGroupCode });
                if (response.status === 200) {
                  setOpen(false);
                    setmdpgrid(response.data.data);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }
        };
        fetchData();
    }, []);

   
  
    const [branches, setBranches] = useState([]); 
    const [selectedBranch, setSelectedBranch] = useState(null);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.post(BASE_URL + '/mdpgetBranches', { login_id  ,userGroupCode:userGroupCode});
          
          if (response.status === 200) {
            const branchData = response.data.branches;
  
            if (branchData && branchData.length > 0) {
              // Map the response to format { value: BRANCH_CODE, label: BRANCH_NAME }
              const formattedBranches = branchData.map((branch) => ({
                value: branch.BRANCH_CODE,
                label: branch.BRANCH_NAME,
              }));
  
              setBranches(formattedBranches);

              console.log('branches',branches);
  
              // Set the first branch as the default selection
              setSelectedBranch(formattedBranches[0]);
            }
  
          } else {
            Swal.fire({
              icon: "warning",
              text: 'Unexpected response status. Please try again.',
            });
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          if (error.response) {
            Swal.fire({
              icon: "warning",
              text: `Error: ${error.response.data.message}`,
            });
          } else if (error.request) {
            console.error('No response received');
          } else {
            console.error('Error setting up the request:', error.message);
          }
        }
      };
  
      fetchData();
    }, [login_id]);  // This effect runs when login_id changes
    const handleBranchChange = (event, selectedOption) => {
        // This will be triggered when a branch is selected from the dropdown
        setSelectedBranch(selectedOption);  // Update the selected branch
      };
    
   

  

    const [isCheckedassign, setIsCheckedassign] = useState(false);
    const [isCheckedview, setIsCheckedview] = useState(false);

    // Handle checkbox state change
    const handleassignCheckboxChange = (event) => {

    
        setIsCheckedassign(event.target.checked);

        setShowactivity(true);
        setexecutivedetails(false);
        setShowfirstpage(false); 
        

    };
    const handleviewCheckboxChange = (event) => {
        setIsCheckedview(event.target.checked);
    };

    const [open1, setOpen1] = useState(false);

    const handleToggle = () => setOpen1(!open1);
    const [searchTerm, setSearchTerm] = useState('');

 
    let mdpgrid1 = mdpgrid || []; // If mdpgrid is undefined or null, initialize it as an empty array

    const filteredItems = mdpgrid1.filter((row) => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        
        return (
            (row.LOGINID && row.LOGINID.toLowerCase().includes(lowerSearchTerm)) ||
            (row.DEALER_NAME && row.DEALER_NAME.toLowerCase().includes(lowerSearchTerm)) ||
            (row.EXECUTIVE_USER_ID && row.EXECUTIVE_USER_ID.toLowerCase().includes(lowerSearchTerm)) ||
            (row.BRANCH_CODE && row.BRANCH_CODE.toLowerCase().includes(lowerSearchTerm))
        );
    });
    
    const [dealercode ,setdealercode]=useState(null)
    const [dealername ,setdealername]=useState(null)
    const [execode ,setexecode]=useState(null)
    const [exename ,setexename]=useState(null)
    const [branch1 ,setbranch1]=useState(null)

    const handleOpenCard = (rowData) => {
      setOpen(true);
      setShowfirstpage(false);
      setShowactivity(true);
    
      setdealercode(rowData.LOGINID);
      setdealername(rowData.DEALER_NAME);
      setexecode(rowData.EXECUTIVE_USER_ID);
      setexename(rowData.EXE_NAME);
      setbranch1(rowData.BRANCH_CODE); 
      setOpen(false);

  };
  const [selectedtoDate, setSelectedtoDate] = useState(dayjs());
  const handletoDateChange = (date) => {
    setSelectedtoDate(date);
};
const [selectedfromDate, setSelectedfromDate] = useState(dayjs());
const handlefromDateChange = (date) => {
  setSelectedfromDate(date);
};
    return (
        <>
            <br />
          
            <div className="container" style={{ justifyContent: 'center' }}>

                <br />
                {showfirstpage &&(
                  <>
                <div className='row'>
                <div className='col-md-4'>
                 {/* <label ></label> */}
                <Autocomplete
        label="Branch"
        required={true}
        options={branches}  // Pass the mapped branches here
        value={selectedBranch}  // Set the selected branch
        onChange={handleBranchChange}  // Handle the change event
        getOptionLabel={(option) => option.label}  // Define how to display the label
        isOptionEqualToValue={(option, value) => option.value === value.value}  // Custom comparison function
        renderInput={(params) => <TextField {...params} label="Branch" />}
      />
   

                    </div>
                    <div className='col-md-4'>

  <Autocomplete
        label="Employee"
        required={true}
        options={subdealerlist}  // Pass the mapped branches here
        value={selectedGroup}  // Set the selected branch
        onChange={handleGroupChange}  // Handle the change event
        getOptionLabel={(option) => option.label}  // Define how to display the label
        isOptionEqualToValue={(option, value) => option.Value === value.Value}  // Custom comparison function
        renderInput={(params) => <TextField {...params} label="Employee" />}
      />

                      

                    </div>

                    <div className='col-md-4'>
                        {/* <label >E-Code</label> */}

                       <Autocomplete
      label="DDP Year"
      required={true}
      options={financialYearOptions}  // Pass the generated options here
      value={selectedItem}  // Set the selected item
      onChange={handleItemChange}  // Handle the change event
      getOptionLabel={(option) => option.Label}  // Display the Label
      isOptionEqualToValue={(option, value) => option.Value === value.Value}  // Custom comparison
      renderInput={(params) => <TextField {...params} label="DDP Year" />}
    />

                        {/* <SelectSearch
                            label="DDP Year"
                            required={true}
                            options={generateFinancialYearOptions()}
                            getOptionLabel={getOptionLabel}
                            value={selectedItem}
                            onChange={handleItemChange}
                        /> */}
                    </div>
                </div>
                <br />
                <div className='row'>
                <div className="col-md-4">
                    {/* <Button size="small" fullWidth variant="contained" onClick={handlePriceList} ><b>View</b></Button> */}
                    <Button size="small" fullWidth variant="contained" ><b>View</b></Button>
                    </div>
                    {showcommon && ( 
                
                    <div className="col-md-4">
                <label className="form-label" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                    Assign Common Activity
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input
                    type="checkbox"
                    checked={isCheckedassign}
                    onChange={handleassignCheckboxChange}
                />
                </div>
                )}

                <div className="col-md-4">
                {/* <label className="form-label" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                    View Common Activity
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input
                    type="checkbox"
                    checked={isCheckedview}
                    onChange={handleviewCheckboxChange}
                /> */}
                </div>
                </div>
                {/* <hr /> */}
         

        <div style={{ border: '1px solid #ddd', borderRadius: '8px' }}>
            {/* Button to toggle the dropdown */}
            <Button
                variant="outlined" // Change to outlined for a consistent border style
                color="primary"
                startIcon={open1 ? <ExpandLess /> : <ExpandMore />}
                onClick={handleToggle}
                fullWidth
                style={{
                    borderBottom: '1px solid #ddd', // Border at the bottom of the button
                    borderRadius: '8px 8px 0 0', // Rounded corners at the top
                    marginBottom: 0, // Remove margin so it aligns with the table
                    padding: '7px', // Increase padding to make it clickable and uniform with table
                    textAlign: 'left', // Align text to the left
                }}
            >
                {open1 ? 'Hide Pending Status' : 'Show Pending Status'}
            </Button>

            {/* Collapsible Dropdown (table visibility) */}
            <Collapse in={open1}>
            <div  className='row'>
            <div className="col-md-6">
               
                <TableContainer component={Paper} style={{ borderTop: '1px solid #ddd' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }} >Status</TableCell>
                                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }}>Count</TableCell>
                              
                               
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {pendingStatusCount.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.Status}</TableCell>
              <TableCell>{row.cnt}</TableCell>
            </TableRow>
          ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                </div>

                <div className="col-md-6">
               
               <TableContainer component={Paper}  sx={{ width: '100%', maxHeight: '380px', overflow: 'auto' }}>
                   <Table stickyHeader>
                       <TableHead>
                           <TableRow>
                               <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }} >DOC.NO</TableCell>
                               <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }} >FYEAR</TableCell>
                               <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }} >DEALER_CODE</TableCell>
                               <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }} >STATUS</TableCell>
                            
                             
                              
                           </TableRow>
                       </TableHead>

                       <TableBody >
        {pendingStatus.map((row, index) => (
          <TableRow key={index}>
            <TableCell>{row.Doc_no}</TableCell>
            <TableCell>{row.Fyear}</TableCell>
            <TableCell>{row.DEALER_CODE}</TableCell>
            <TableCell>{row.Status}</TableCell>
          </TableRow>
        ))}
      </TableBody>
                       {/* <TableBody>
                           {pendingStatus.map((row, index) => (
                               <TableRow key={index}>
                                   <TableCell>{row.Doc_no}</TableCell>
                                   <TableCell>{row.Fyear}</TableCell>
                                   <TableCell>{row.DEALER_CODE}</TableCell>
                                   <TableCell>{row.Status}</TableCell>
                                   
                               </TableRow>
                           ))}
                       </TableBody> */}
                   </Table>
               </TableContainer>
               </div>
                

                </div>
            </Collapse>
        </div>
                <br />
                {showTable && ( 
                <div>
            {/* <hr /> */}
            <TextField
            id="filled-search"
            label="Search field"
            type="search"
            variant="filled"

            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: <SearchIcon />,
            }}
          />

         
            <TableContainer component={Paper}    sx={{ width: '100%', maxHeight: '400px', overflow: 'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }}>S.No</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }}>Dealer Code</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>Dealer Name</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1  }}>Executive ID </TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1  }}>Executive Name </TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>Branch Code</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {filteredItems.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          No data available
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredItems.map((row, index) => (
                        <>
                    {/* {mdpgrid && mdpgrid.map((row, index) => ( */}
                             <TableRow key={index}>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{index + 1}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.LOGINID}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.DEALER_NAME}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.EXECUTIVE_USER_ID}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.EXE_NAME}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.BRANCH_CODE}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>
                                  
                                    <Button variant="contained" onClick={() => handleOpenCard(row)}  color="primary" >Add</Button>
                                   {/* <Button variant="contained"   onClick={() => handleOpenCard(row)} color="primary" >Delivery Challan</Button> */} 
                                </TableCell>
                            </TableRow> 
                       {/* ))} */}
</>
                      ))
                    )}
                    </TableBody>
                </Table>
            </TableContainer>
            
            </div>
)}
</>
)}

{showactivity && (
  <>
<div>
<center><h3 style={{ padding: '2px', background: '#e3fafe', color: 'black' }} >Market Development Plan</h3></center>
{showexecutivedetails &&(
  <><Card style={{
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: 'auto', // Adjust the height to fit content
    maxHeight: '300px', // Set a maximum height
    
    padding: '20px', // Add padding to prevent the content from touching the edges
    boxSizing: 'border-box',
    
}}>

    <Box>
       
        <div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>PlanYear<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <TextField
                disabled
                    fullWidth
                    id="PlanYear"
                    label=""
                    variant="outlined"
                    value={selectedItem ? selectedItem.Label : ''}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

     

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Dealer Code<span style={{ color: 'red' }}> *</span></label>
                <br />  

                <TextField
                disabled
                    fullWidth
                    id="DealerCode"
                    label=""
                    variant="outlined"
                    value={dealercode}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Dealer Name<span style={{ color: 'red' }}> *</span></label>
                <br /> 

          
                <TextField
                disabled
                    fullWidth
                    id="dealername"
                    label=""
                    variant="outlined"
                    value={dealername}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>
        </div>
        
 
        <div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Branch<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <TextField
                disabled
                    fullWidth
                    id="name"
                    label=""
                    variant="outlined"
                    value={branch1}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Exe Code<span style={{ color: 'red' }}> *</span></label>
                <br /> 
               

                <TextField
                disabled
                    fullWidth
                    id="ExeCode"
                    label=""
                    variant="outlined"
                    value={execode}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Exe Name<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <TextField
                disabled
                    fullWidth
                    id="ExeName"
                    label=""
                    variant="outlined"
                    value={exename}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>
        </div>

    </Box>
</Card>
</>
)}


</div><br/>
<div>

<Card style={{
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: 'auto', // Adjust the height to fit content
    // maxHeight: '300px', // Set a maximum height
    
    padding: '20px', // Add padding to prevent the content from touching the edges
    boxSizing: 'border-box',
    
}}>

    <Box>
        <center><h3 style={{ padding: '2px', background: '#e3fafe', color: 'black',fontweight:'bolder' }} >Activity Details</h3></center>
        <div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Sr.NO<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <TextField
                disabled
                    fullWidth
                    id="PlanYear"
                    label=""
                    variant="outlined"
                    value="AUTO GENERATED"
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

     

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Activity Group<span style={{ color: 'red' }}> *</span></label>
                <br />  

                <Autocomplete
  label=""
  required={true}
  options={activitygrouplist}  // Pass the mapped branches here
  value={selectedactivitygroup}  // Set the selected branch
  onChange={handleactivityGroupChange}  // Handle the change event
  getOptionLabel={(option) => option.label}  // Define how to display the label
  isOptionEqualToValue={(option, value) => option.Value === value.Value}  // Custom comparison function
  renderInput={(params) => (
    <TextField
      {...params}
      label=""
      InputProps={{
        ...params.InputProps,  // Retain any existing input properties
        style: {
          height: '35px', // Adjust this value to set the desired height
          padding: '5px 10px', // Adjust padding to further control the height
        },
      }}
      InputLabelProps={{
        style: {
          fontSize: '0.9rem', // Optional: change font size if needed
        },
      }}
    />
  )}
/>
            </div>

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Activity Description<span style={{ color: 'red' }}> *</span></label>
                <br /> 

          
                <Autocomplete
        label=""
        required={true}
        options={activitydescriptionlist}  // Pass the mapped branches here
        value={selecteddescriptiongroup}  // Set the selected branch
        onChange={handledescriptionGroupChange}  // Handle the change event
        getOptionLabel={(option) => option.label}  // Define how to display the label
        isOptionEqualToValue={(option, value) => option.Value === value.Value}  // Custom comparison function
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            InputProps={{
              ...params.InputProps,  // Retain any existing input properties
              style: {
                height: '35px', // Adjust this value to set the desired height
                padding: '5px 10px', // Adjust padding to further control the height
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: '0.9rem', // Optional: change font size if needed
              },
            }}
          />
        )}
      />
            </div>
        </div>
        
 
        <div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>From Date<span style={{ color: 'red' }}> *</span></label>
                <br /> 

               <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={2}>
        <DatePicker
          value={selectedfromDate}  // Ensure `value` is a dayjs object
          onChange={handlefromDateChange}
          format="DD/MM/YYYY"
          label=""
          inputRef={fromdateInputRef}
          error={!!errorfromdate}
          helperText={errorfromdate}
          sx={{
            '& .MuiInputBase-root': {
              height: '40px',
            },
          }}
          InputProps={{
            style: {
              height: '40px',
              padding: '5px 10px',
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
            </div>

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>To Date<span style={{ color: 'red' }}> *</span></label>
                <br /> 
               

                <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={2}>
        <DatePicker
          value={selectedtoDate}  // Ensure `value` is a dayjs object
          onChange={handletoDateChange}
          format="DD/MM/YYYY"
          label=""
          inputRef={todateInputRef}
          error={!!errortodate}
          helperText={errortodate}
          sx={{
            '& .MuiInputBase-root': {
              height: '40px',
            },
          }}
          InputProps={{
            style: {
              height: '40px',
              padding: '5px 10px',
            },
          }}
        />
      </Stack>
    </LocalizationProvider>

            </div>

            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Segment<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <Autocomplete
        label=""
        required={true}
        options={segmentlist}  // Pass the mapped branches here
        value={selectedsegment}  // Set the selected branch
        onChange={handlesegmentChange}  // Handle the change event
        getOptionLabel={(option) => option.label}  // Define how to display the label
        isOptionEqualToValue={(option, value) => option.Value === value.Value}  // Custom comparison function
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            InputProps={{
              ...params.InputProps,  // Retain any existing input properties
              style: {
                height: '35px', // Adjust this value to set the desired height
                padding: '5px 10px', // Adjust padding to further control the height
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: '0.9rem', // Optional: change font size if needed
              },
            }}
          />
        )}
      />
            </div>
        </div>

        <div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Activity Objective<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <TextField
               
                    fullWidth
                    id="name"
                    label=""
                    variant="outlined"
                    value={description}
                     onChange={(e) => setdescription(e.target.value)}
                    inputRef={activityobjectInputRef}
                    error={!!erroractivityobject}
                    helperText={erroractivityobject}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

            <div className='col-md-4'>
             
                <label style={{ fontWeight: 'bolder' }}>
                {labels.Lblspec} <span style={{ color: 'red' }}>*</span>
            </label>
            <br />

          

            <TextField
                fullWidth
                id="ExeName"
                label=""
                variant="outlined"
                value={txtSPECIFIC_DETAILS}
                onChange={handleTextChange}

              

                inputRef={billNoInputRef}
                    error={!!error}
                    helperText={error}

                InputProps={{
                    style: {
                        height: '35px', // Adjust this value to set the desired height
                        padding: '5px 10px', // Adjust padding to further control the height
                    },
                }}
                InputLabelProps={{
                    style: {
                        fontSize: '0.9rem', // Optional: change font size if needed
                    },
                }}
            />
            </div>

            <div className='col-md-4'>
           

            {visibility.Lblspec2 && (
                <div>
                    <label style={{ fontWeight: 'bolder' }}>
                        {labels.Lblspec2} <span style={{ color: 'red' }}>*</span>
                    </label>
                    <br />

                    {dropDownListVisible ? (
  <Autocomplete
    label=""
    required={true}
    options={dropDownList}  // Pass the mapped descriptions here
    value={selectedDropDownList}  // Set the selected description
    onChange={handledeDropDownListChange}  // Handle the change event
    getOptionLabel={(option) => option.label}  // Define how to display the label
    isOptionEqualToValue={(option, value) => option.value === value.value}  // Custom comparison function
    renderInput={(params) => (
      <TextField
        {...params}
        label=""
        InputProps={{
          ...params.InputProps,  // Retain any existing input properties
          style: {
            height: '35px', // Adjust this value to set the desired height
            padding: '5px 10px', // Adjust padding to further control the height
          },
        }}
        InputLabelProps={{
          style: {
            fontSize: '0.9rem', // Optional: change font size if needed
          },
        }}
      />
    )}
  />
) : (
  <TextField
    fullWidth
    id="ExeName"
    label=""
    variant="outlined"
    value={txtSPECIFIC_DETAILS2}
    onChange={handleTextChange2}
     inputRef={txtSPECIFIC_DETAILS2InputRef}
                    error={!!errortxtSPECIFIC_DETAILS2}
                    helperText={errortxtSPECIFIC_DETAILS2}
    InputProps={{
      style: {
        height: '35px', // Adjust this value to set the desired height
        padding: '5px 10px', // Adjust padding to further control the height
      },
    }}
    InputLabelProps={{
      style: {
        fontSize: '0.9rem', // Optional: change font size if needed
      },
    }}
  />
)}
                </div>
            )}

            {/* {dropDownListVisible && (
                <div>
                    <label>Choose an option:</label>
                    <select>
                        {dropDownList.map((item, index) => (
                            <option key={index} value={item}>
                                {item}
                            </option>
                        ))}
                    </select>
                </div>
            )} */}
        </div>
        </div>
        {fileupload && (
        <div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>UplaodFile<span style={{ color: 'red' }}> *</span></label>
                <br />
                {/* <Upload
      fileList={upload}  // Use the state for file list
      onChange={handleuploadChange}  // Handle changes
      accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.xls,.xlsx,.doc,.docx,.zip,.txt,.csv"  // Accept multiple file types
      showUploadList={{ showPreviewIcon: true, showRemoveIcon: true }} // Optional: Show preview and remove icon
      maxCount={1}  // Only allow 1 file (remove or change if you want more)
    > */}
 <Upload   {...createInvoiceImageProps(serialNoImage, setSerialNoImage)} maxCount={1}>
                <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Account Statements *</Btn>
              </Upload>
{/* <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Upload Files</Btn> */}
      {/* <Button icon={<UploadOutlined />} style={{ width: '100%' }}>
        
      </Button> */}
    {/* </Upload> */}
              </div>
          </div>
        )}

<div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Budget (Rs.)<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <TextField
               
                    fullWidth
                    id="name"
                    label=""
                     inputRef={budgetInputRef}
                    error={!!errorbudget}
                    helperText={errorbudget}
                    variant="outlined"
                    value={budget}
                    onChange={(e) => setbudget(e.target.value)}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

            <div className='col-md-4'>
             
                <label style={{ fontWeight: 'bolder' }}>
                Remark <span style={{ color: 'red' }}>*</span>
            </label>
            <br />

          

            <TextField
                fullWidth
                id="ExeName"
                label=""
                variant="outlined"
                value={Remark}
                onChange={(e) => setRemark(e.target.value)}
                    
                InputProps={{
                    style: {
                        height: '35px', // Adjust this value to set the desired height
                        padding: '5px 10px', // Adjust padding to further control the height
                    },
                }}
                InputLabelProps={{
                    style: {
                        fontSize: '0.9rem', // Optional: change font size if needed
                    },
                }}
            />
            </div>
            <div className='col-md-4'>
             
                <label style={{ fontWeight: 'bolder' }}>
                Dealer Contribution (Rs.) <span style={{ color: 'red' }}>*</span>
            </label>
            <br />

          

            <TextField
                fullWidth
                id="ExeName"
                label=""
                variant="outlined"
                value={dealerbudget}
                onChange={(e) => setdealerbudget(e.target.value)}
                inputRef={dealerbudgetInputRef}
                    error={!!errordealerbudget}
                    helperText={errordealerbudget}
                InputProps={{
                    style: {
                        height: '35px', // Adjust this value to set the desired height
                        padding: '5px 10px', // Adjust padding to further control the height
                    },
                }}
                InputLabelProps={{
                    style: {
                        fontSize: '0.9rem', // Optional: change font size if needed
                    },
                }}
            />
            </div>
            </div>

            <div className='row'>
            <div className='col-md-4'>
                <label style={{fontWeight:'bolder'}}>Remark<span style={{ color: 'red' }}> *</span></label>
                <br /> 

                <TextField
               
                    fullWidth
                    id="name"
                    label=""
                    variant="outlined"
                    value={dealerremark}
                    onChange={(e) => setdealerremark(e.target.value)}
                    inputRef={dealerremarkInputRef}
                    error={!!errordealerremark}
                    helperText={errordealerremark}
                    InputProps={{
                      style: {
                          height: '35px', // Adjust this value to set the desired height
                          padding: '5px 10px', // Adjust padding to further control the height
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '0.9rem', // Optional: change font size if needed
                      },
                  }}
                />
            </div>

            <div className='col-md-4'>
             
                <label style={{ fontWeight: 'bolder' }}>
                Exp. Result On Sales (Rs.) <span style={{ color: 'red' }}>*</span>
            </label>
            <br />

          

            <TextField
  fullWidth
  id="ExeName"
  label=""
  variant="outlined"
  value={expresult}
  onChange={(e) => {
    const value = e.target.value;
    
    // Allow only numbers and a single dot
    const regex = /^[0-9]*\.?[0-9]*$/;

    // Check if the value matches the allowed pattern
    if (regex.test(value)) {
      setexpresult(value);
    }
  }}
  InputProps={{
    style: {
      height: '35px', // Adjust this value to set the desired height
      padding: '5px 10px', // Adjust padding to further control the height
    },
  }}
  InputLabelProps={{
    style: {
      fontSize: '0.9rem', // Optional: change font size if needed
    },
  }}
/>
            </div>
           
            </div>

    </Box>
</Card>

<div className='row'>
<div className="col-md-4">
  </div>
                <div className="col-md-4">
                    {/* <Button size="small" fullWidth variant="contained" onClick={handlePriceList} ><b>View</b></Button> */}
                    <Button size="small" fullWidth variant="contained" onClick={handlesubmit} ><b>SUBMIT</b></Button>
                    </div>
                    </div>

</div>

</>

)}
                <br />

                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>


            </div>
        </>
    );
};


